import React from 'react';
import styles from './loader.module.scss';
interface ICircularProgressProps {
  size?: number; // Size of the loader
  thickness?: number; // Thickness of the loader
  color?: string; // Color of the loader
}

const Loader: React.FC<ICircularProgressProps> = ({
  size = 40,
  thickness = 4,
  color = '#4e55a2', // Default Material-UI primary blue
}) => {
  const borderWidth = thickness;
  const diameter = size;

  return (
    <div
      className={styles.loader}
      style={{
        width: diameter,
        height: diameter,
        borderWidth: borderWidth,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
  );
};

export default Loader;
